import { useFetch } from "@/hooks/useFetch";

export function useLookups() {
  const { data: locations } = useFetch("/master/locations");
  const { data: departments } = useFetch("/master/departments");
  const { data: users } = useFetch("/users");
  const { data: vendors } = useFetch("/master/vendors");
  const opt = (arr, labelFn, valueKey = "id") => (arr || []).map((x) => ({ value: x[valueKey], label: labelFn(x) }));
  const nameOf = (arr, id, key = "name") => (arr || []).find((x) => x.id === id)?.[key] || "—";
  return {
    locations: locations || [], departments: departments || [], users: users || [], vendors: vendors || [],
    locOpts: opt(locations, (l) => `${l.code} · ${l.name}`), deptOpts: opt(departments, (d) => d.name),
    userOpts: opt(users, (u) => `${u.name} (${u.role})`), vendorOpts: opt(vendors, (v) => v.name),
    locName: (id) => nameOf(locations, id), deptName: (id) => nameOf(departments, id), userName: (id) => nameOf(users, id), vendorName: (id) => nameOf(vendors, id),
  };
}
